import TxMccsLogo from '@/assets/TxMCCS_logo_swoosh_final.png'
import { buildPath } from '@/routes'
import type { ReactNode } from 'react'
import { Link, Outlet } from 'react-router'

interface BareLayoutProps {
  // Only needed when used outside the router tree (e.g. Login, rendered
  // directly by RequireAuth rather than as a routed <Outlet> child).
  children?: ReactNode
}

// Landmark-only shell for pages that don't want the shared Header/topbar
// (e.g. Signup, SignupEmailSent, Login), but still share the same
// logo-topped, centered-column chrome as each other.
export function BareLayout({ children }: BareLayoutProps) {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <main
        id="main-content"
        className="bg-muted flex min-h-screen flex-col gap-8 px-4 py-10"
      >
        <Link to={buildPath('/')} className="self-center">
          <img
            src={TxMccsLogo}
            alt="TxMCCS Logo"
            className="h-15 object-scale-down sm:h-20"
          />
        </Link>

        {children ?? <Outlet />}
      </main>
    </>
  )
}

export default BareLayout
